import {
  CORE_LOAD_ALL_IOTROOM_REQUEST,
  CORE_LOAD_ALL_IOTROOM_SUCCESS,
  CORE_LOAD_ALL_IOTROOM_FAILURE,

  CORE_LOAD_IOTROOM_REQUEST,
  CORE_LOAD_IOTROOM_SUCCESS,
  CORE_LOAD_IOTROOM_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allIOTRoom: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_IOTROOM_REQUEST:
        return requestState
      case CORE_LOAD_ALL_IOTROOM_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_IOTROOM_FAILURE:
        return initialState
      default:
        return state
    }
  },
  IOTRoomInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_IOTROOM_REQUEST:
        return requestState
      case CORE_LOAD_IOTROOM_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_IOTROOM_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerIOTRoom.js